// MF-67 — Share of entries by type (part-to-whole): donut with the total in the centre, 2px surface
// gaps between slices, and name + % labels outside (direct labels). Tenant types, in their order.
import { useMemo } from 'react'
import ReactECharts from 'echarts-for-react'
import {
  FONT,
  INK,
  baseTextStyle,
  tooltipBase,
  fmtNumber,
  fmtPct,
  orderedTypes,
  typeStyle
} from './chartTheme'

const TypeDonut = ({ byType = [], types = { list: [], byCode: new Map() }, height = 300 }) => {
  const option = useMemo(() => {
    const total = byType.reduce((s, r) => s + r.count, 0)
    const codes = orderedTypes(
      byType.filter((r) => r.count > 0).map((r) => r.type),
      types.list
    )
    const data = codes.map((code) => {
      const st = typeStyle(code, types.byCode)
      return {
        name: st.label,
        value: byType.find((r) => r.type === code)?.count || 0,
        itemStyle: { color: st.color }
      }
    })
    return {
      textStyle: baseTextStyle,
      animationDuration: 400,
      tooltip: {
        ...tooltipBase,
        trigger: 'item',
        formatter: ({ name, value }) => `${name}<br/><b>${fmtNumber(value)}</b> · ${fmtPct(value, total)}`
      },
      title: {
        text: fmtNumber(total),
        subtext: 'entries',
        left: 'center',
        top: 'center',
        itemGap: 2,
        textStyle: { fontFamily: FONT, fontSize: 22, fontWeight: 600, color: INK.primary },
        subtextStyle: { fontFamily: FONT, fontSize: 12, color: INK.secondary }
      },
      series: [
        {
          type: 'pie',
          radius: ['54%', '74%'],
          center: ['50%', '50%'],
          avoidLabelOverlap: true,
          itemStyle: { borderColor: INK.surface, borderWidth: 2, borderRadius: 4 },
          label: {
            formatter: ({ name, value }) => `{n|${name}}\n{p|${fmtPct(value, total)}}`,
            rich: {
              n: { fontFamily: FONT, fontSize: 12, color: INK.secondary, lineHeight: 16 },
              p: { fontFamily: FONT, fontSize: 13, fontWeight: 600, color: INK.primary, lineHeight: 18 }
            }
          },
          labelLine: { length: 10, length2: 10, lineStyle: { color: INK.axis } },
          emphasis: { scale: true, scaleSize: 4 },
          data
        }
      ]
    }
  }, [byType, types])

  return (
    <ReactECharts option={option} notMerge style={{ height, width: '100%' }} opts={{ renderer: 'svg' }} />
  )
}

export default TypeDonut
